import React from 'react';
import ProfileForm from '../components/profile/ProfileForm';

const ProfilePage = () => {
  return <ProfileForm />;
};

export default ProfilePage;